import { getUserQrInfo } from '@apis/cp/cp-auth';
import { Button, Modal, Toast } from '@common-web/index';
import { strings } from '@constants/strings';
import { getErrorString } from '@utils/utils';
import { Flex, Image, Spin } from 'antd';
import QRCode from 'qrcode';
import { useState } from 'react';

const QRCodeGenerator = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const generateQRCode = async () => {
    setIsGenerating(true);
    try {
      const res = await getUserQrInfo();
      if (res?.success) {
        const dataString = JSON.stringify(res?.qr_info);
        const url = await QRCode.toDataURL(dataString);
        setIsModalOpen(url);
      }
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <Modal
        open={!!isModalOpen}
        title={strings.scan_to_connect}
        width={'672px'}
        handleCancel={() => setIsModalOpen(null)}
        closable
        showActions={false}
        ModalBody={
          <Flex align={'center'} justify={'center'}>
            <Image width={260} height={260} src={isModalOpen} alt="Generated QR Code" preview={false} />
          </Flex>
        }
      />

      <Flex className="cursor-pointer" align="center" gap={8} onClick={generateQRCode}>
        <span className="fw-600">{strings.scan_to_connect}</span>
        {isGenerating && <Spin size="small" />}
      </Flex>
    </>
  );
};

export default QRCodeGenerator;
